import { render, staticRenderFns } from "./NAO_Categoriascarousel.vue?vue&type=template&id=1592c686&scoped=true&"
import script from "./NAO_Categoriascarousel.vue?vue&type=script&lang=js&"
export * from "./NAO_Categoriascarousel.vue?vue&type=script&lang=js&"
import style0 from "./NAO_Categoriascarousel.vue?vue&type=style&index=0&id=1592c686&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1592c686",
  null
  
)

export default component.exports